// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.proxy_modal {
    display: none;
    position: absolute;
    inset: 0;
    background: var(--color-bg);
    z-index: 1500;
    flex-direction: column;
    overflow: hidden;
}

.proxy_modal--open {
    display: flex;
}

/* Touch/mobile: use fixed so it covers the whole viewport */
@media (pointer: coarse) {
    .proxy_modal {
        position: fixed;
    }
}

.proxy_modal--mobile-view {
    background: var(--color-bg-2);
}

.proxy_modal__toolbar {
    flex-shrink: 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    gap: 8px;
    padding: 0 10px;
    height: 52px;
    border-bottom: 1px solid var(--color-border);
    background: var(--color-bg-2);
}

.proxy_modal__content {
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
    position: relative;
}

.proxy_modal__split {
    flex: 1;
    min-height: 0;
}

.proxy_modal__browser_area {
    flex: 1;
    min-height: 0;
    position: relative;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.proxy_modal__browser_area--split {
    height: 100%;
    flex: none;
}

.proxy_modal__btn {
    flex-shrink: 0;
    width: 32px;
    height: 32px;
    border-radius: 6px;
    border: 1px solid var(--color-border);
    background: transparent;
    color: var(--color-text-muted);
    font-size: 13px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    transition: color 0.1s, background-color 0.1s;
}

.proxy_modal__btn.active {
    color: var(--color-accent, #4a6cf7);
    border-color: var(--color-accent, #4a6cf7);
}

@media (pointer: fine) {
    .proxy_modal__btn:hover {
        color: var(--color-text);
        background-color: var(--color-bg-3);
    }
}

/* Landscape mobile: compact toolbar height to preserve vertical space */
@media (pointer: coarse) and (min-aspect-ratio: 1) {
    .proxy_modal__toolbar {
        height: 40px;
        padding: 0 8px;
    }
}

.proxy_modal__scroller {
    flex: 1;
    overflow: auto;
    -webkit-overflow-scrolling: touch;
    min-height: 0;
}

.proxy_modal__scroller--mobile {
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    touch-action: none;
}

.proxy_modal__frame {
    border: none;
    display: block;
}

.proxy_modal--mobile-view .proxy_modal__frame {
    box-shadow: 0 0 0 1px var(--color-border), 0 8px 32px rgba(0, 0, 0, 0.4);
}

.proxy_modal__url_form {
    flex: 1;
    min-width: 0;
    display: flex;
}

.proxy_modal__url_input {
    flex: 1;
    min-width: 0;
    height: 28px;
    padding: 0 10px;
    border-radius: 14px;
    border: 1px solid var(--color-border);
    background: var(--color-bg);
    color: var(--color-text);
    font-size: 12px;
    outline: none;
    transition: border-color 0.1s;
}

.proxy_modal__url_input:focus {
    border-color: var(--color-accent, #4a6cf7);
}

/* TextInput overrides — make it look like the pill-shaped URL bar */
.proxy_modal__url_form .text_input__touch_wrapper {
    flex: 1;
    min-width: 0;
}

.proxy_modal__url_input.text_input,
.proxy_modal__url_form .text_input {
    flex: 1;
    min-width: 0;
    height: 28px;
    padding: 0 10px;
    border-radius: 14px;
    font-size: 12px;
}

.proxy_modal__url_input.text_input--vkb-active,
.proxy_modal__url_form .text_input--vkb-active {
    border-color: var(--color-accent, #4a6cf7);
}

.proxy_modal__url_form .text_input__cursor_overlay {
    height: 28px;
    padding: 0 10px;
    border-radius: 14px;
    font-size: 12px;
    line-height: 28px;
}

.proxy_modal__pinch_overlay {
    position: absolute;
    inset: 0;
    z-index: 5;
    touch-action: none;
}

.proxy_modal__preloader {
    position: absolute;
    inset: 0;
    z-index: 4;
    display: flex;
    align-items: center;
    justify-content: center;
    background: var(--color-bg);
    pointer-events: none;
}

.proxy_modal__preloader--overlay {
    background: rgba(0, 0, 0, 0.45);
}

.proxy_modal__spinner {
    width: 32px;
    height: 32px;
    border: 3px solid rgba(255, 255, 255, 0.1);
    border-top-color: var(--color-accent, #4a6cf7);
    border-radius: 50%;
    animation: proxy_modal_spin 0.8s linear infinite;
}

@keyframes proxy_modal_spin {
    to { transform: rotate(360deg); }
}

.proxy_modal__content_controls {
    position: absolute;
    bottom: 12px;
    right: 12px;
    z-index: 10;
    display: flex;
    flex-direction: column;
    gap: 6px;
    pointer-events: auto;
}

.proxy_modal__content_controls .proxy_modal__btn {
    background: var(--color-bg-2, #242424);
    opacity: 0.85;
}

.proxy_modal__content_controls .proxy_modal__btn:hover {
    opacity: 1;
}

/* Display config panel */

.proxy_modal__display_config {
    position: absolute;
    bottom: calc(100% + 8px);
    right: 0;
    min-width: 170px;
    background: var(--color-bg-2, #1e1e1e);
    border: 1px solid var(--color-border, #333);
    border-radius: 8px;
    padding: 6px 0;
    box-shadow: 0 4px 16px rgba(0,0,0,0.5);
    z-index: 20;
}

.proxy_modal__display_config_section {
    padding: 4px 10px 2px;
    font-size: 10px;
    font-weight: 600;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: var(--color-text-muted);
    opacity: 0.6;
}

.proxy_modal__display_config_item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: 5px 10px;
    background: none;
    border: none;
    cursor: pointer;
    gap: 8px;
    transition: background-color 0.1s;
}

.proxy_modal__display_config_item:hover {
    background: var(--color-bg-3, rgba(255,255,255,0.06));
}

.proxy_modal__display_config_item.active {
    background: rgba(74,108,247,0.12);
}

.proxy_modal__display_config_label {
    font-size: 12px;
    color: var(--color-text, #fff);
    white-space: nowrap;
}

.proxy_modal__display_config_desc {
    font-size: 11px;
    color: var(--color-text-muted);
    font-family: "JetBrains Mono", Menlo, monospace;
    white-space: nowrap;
}

/* DevTools panel */

.proxy_modal__devtools {
    flex-shrink: 0;
    position: relative;
    z-index: 10;
    display: flex;
    flex-direction: column;
    border-top: 1px solid var(--color-border, #333);
    background: var(--color-bg, #1a1a1a);
    overflow: hidden;
}

/* When devtools is inside a Split pane, fill the pane and drop the top border
   (the sash provides the visual separator) */
.split__pane .proxy_modal__devtools {
    height: 100%;
    border-top: none;
}

.proxy_modal__devtools_tabs {
    display: flex;
    align-items: center;
    flex-shrink: 0;
    border-bottom: 1px solid var(--color-border, #333);
    background: var(--color-bg-2, #111);
    padding: 0 4px;
}

.proxy_modal__devtools_tab {
    padding: 6px 14px;
    font-size: 12px;
    color: var(--color-text-muted);
    background: none;
    border: none;
    border-bottom: 2px solid transparent;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 5px;
    margin-bottom: -1px;
    white-space: nowrap;
}

.proxy_modal__devtools_tab.active {
    color: var(--color-text);
    border-bottom-color: var(--color-accent, #4a6cf7);
}

.proxy_modal__devtools_badge {
    font-size: 10px;
    padding: 1px 5px;
    border-radius: 8px;
    background: var(--color-bg-hover, rgba(255,255,255,0.08));
    color: var(--color-text-muted);
    font-weight: 600;
}

.proxy_modal__devtools_badge--error {
    background: rgba(239,68,68,0.2);
    color: #ef4444;
}

.proxy_modal__devtools_clear {
    margin-left: auto;
    padding: 3px 10px;
    font-size: 11px;
    color: var(--color-text-muted);
    background: none;
    border: none;
    cursor: pointer;
    opacity: 0.7;
    transition: opacity 0.1s;
}

@media (pointer: fine) {
    .proxy_modal__devtools_clear:hover { opacity: 1; }
}

.proxy_modal__devtools_body {
    flex: 1;
    overflow-y: auto;
    scrollbar-width: thin;
}

.proxy_modal__devtools_empty {
    padding: 12px;
    font-size: 12px;
    color: var(--color-text-muted);
}

.proxy_modal__devtools_entry {
    display: flex;
    gap: 8px;
    align-items: flex-start;
    padding: 2px 8px;
    border-bottom: 1px solid rgba(255,255,255,0.03);
    font-family: "JetBrains Mono", "Fira Code", Menlo, monospace;
    font-size: 11px;
    line-height: 1.5;
}

.proxy_modal__devtools_entry_level {
    flex-shrink: 0;
    font-weight: 700;
    width: 14px;
    text-align: center;
    opacity: 0.6;
}

.proxy_modal__devtools_entry_text {
    flex: 1;
    white-space: pre-wrap;
    word-break: break-all;
    color: var(--color-text, #fff);
}

.proxy_modal__devtools_entry--error {
    background: rgba(239,68,68,0.08);
}
.proxy_modal__devtools_entry--error .proxy_modal__devtools_entry_level,
.proxy_modal__devtools_entry--error .proxy_modal__devtools_entry_text {
    color: #ef4444;
}

.proxy_modal__devtools_entry--warn {
    background: rgba(234,179,8,0.08);
}
.proxy_modal__devtools_entry--warn .proxy_modal__devtools_entry_level,
.proxy_modal__devtools_entry--warn .proxy_modal__devtools_entry_text {
    color: #eab308;
}

.proxy_modal__devtools_entry--debug .proxy_modal__devtools_entry_text {
    color: var(--color-text-muted);
}

/* Network tab */

.proxy_modal__devtools_net_entry {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 3px 8px;
    border-bottom: 1px solid rgba(255,255,255,0.03);
    font-family: "JetBrains Mono", "Fira Code", Menlo, monospace;
    font-size: 11px;
    line-height: 1.5;
}

.proxy_modal__devtools_net_method {
    flex-shrink: 0;
    width: 38px;
    font-size: 10px;
    font-weight: 700;
    color: var(--color-text-muted);
    text-transform: uppercase;
}

.proxy_modal__devtools_net_url {
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: var(--color-text, #fff);
}

.proxy_modal__devtools_net_status {
    flex-shrink: 0;
    width: 34px;
    text-align: center;
    font-weight: 700;
    font-size: 10px;
}

.proxy_modal__devtools_net_status--ok   { color: #22c55e; }
.proxy_modal__devtools_net_status--err  { color: #ef4444; }
.proxy_modal__devtools_net_status--pending { color: var(--color-text-muted); opacity: 0.5; }

.proxy_modal__devtools_net_dur {
    flex-shrink: 0;
    width: 42px;
    text-align: right;
    color: var(--color-text-muted);
    font-size: 10px;
}

.proxy_modal__devtools_net_type {
    flex-shrink: 0;
    width: 36px;
    font-size: 9px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    color: var(--color-text-muted);
    opacity: 0.6;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.proxy_modal__devtools_resize {
    flex-shrink: 0;
    height: 4px;
    cursor: ns-resize;
    background: transparent;
    transition: background-color 0.1s;
}

.proxy_modal__devtools_resize:hover,
.proxy_modal__devtools_resize--dragging {
    background: var(--color-accent, #4a6cf7);
    opacity: 0.4;
}

.proxy_modal__devtools_filter {
    display: flex;
    align-items: center;
    gap: 2px;
    padding: 3px 6px;
    flex-shrink: 0;
    border-bottom: 1px solid var(--color-border, #333);
    background: var(--color-bg-2, #111);
    overflow-x: auto;
    scrollbar-width: none;
}

.proxy_modal__devtools_filter::-webkit-scrollbar { display: none; }

.proxy_modal__devtools_filter_btn {
    padding: 2px 8px;
    font-size: 11px;
    border-radius: 4px;
    border: 1px solid transparent;
    background: none;
    color: var(--color-text-muted);
    cursor: pointer;
    white-space: nowrap;
    transition: color 0.1s, border-color 0.1s, background-color 0.1s;
}

.proxy_modal__devtools_filter_btn.active {
    color: var(--color-text);
    border-color: var(--color-border, #444);
    background: var(--color-bg-3, rgba(255,255,255,0.06));
}

@media (pointer: fine) {
    .proxy_modal__devtools_filter_btn:hover {
        color: var(--color-text);
        background: var(--color-bg-hover, rgba(255,255,255,0.06));
    }
}

.proxy_modal__console_input_area {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    padding: 4px 8px;
    border-top: 1px solid var(--color-border, #333);
    gap: 6px;
    background: var(--color-bg-2, #111);
}

.proxy_modal__console_input {
    flex: 1;
    background: transparent;
    border: none;
    outline: none;
    color: var(--color-text);
    font-family: "JetBrains Mono", "Fira Code", Menlo, monospace;
    font-size: 12px;
    padding: 0;
    caret-color: var(--color-accent, #4a6cf7);
}

.proxy_modal__console_input::placeholder {
    color: var(--color-text-muted);
    opacity: 0.4;
}
`, "",{"version":3,"sources":["webpack://./components/sections/DeploymentSection/ProxyModal/s.proxy_modal.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,kBAAkB;IAClB,QAAQ;IACR,2BAA2B;IAC3B,aAAa;IACb,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA,4DAA4D;AAC5D;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,yBAAyB;IACzB,QAAQ;IACR,eAAe;IACf,YAAY;IACZ,4CAA4C;IAC5C,6BAA6B;AACjC;;AAEA;IACI,OAAO;IACP,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,OAAO;IACP,aAAa;AACjB;;AAEA;IACI,OAAO;IACP,aAAa;IACb,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,UAAU;AACd;;AAEA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,qCAAqC;IACrC,uBAAuB;IACvB,8BAA8B;IAC9B,eAAe;IACf,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;IACV,6CAA6C;AACjD;;AAEA;IACI,mCAAmC;IACnC,0CAA0C;AAC9C;;AAEA;IACI;QACI,wBAAwB;QACxB,mCAAmC;IACvC;AACJ;;AAEA,wEAAwE;AACxE;IACI;QACI,YAAY;QACZ,cAAc;IAClB;AACJ;;AAEA;IACI,OAAO;IACP,cAAc;IACd,iCAAiC;IACjC,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,wEAAwE;AAC5E;;AAEA;IACI,OAAO;IACP,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,OAAO;IACP,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,mBAAmB;IACnB,qCAAqC;IACrC,2BAA2B;IAC3B,wBAAwB;IACxB,eAAe;IACf,aAAa;IACb,6BAA6B;AACjC;;AAEA;IACI,0CAA0C;AAC9C;;AAEA,oEAAoE;AACpE;IACI,OAAO;IACP,YAAY;AAChB;;AAEA;;IAEI,OAAO;IACP,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,mBAAmB;IACnB,eAAe;AACnB;;AAEA;;IAEI,0CAA0C;AAC9C;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,mBAAmB;IACnB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,2BAA2B;IAC3B,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,0CAA0C;IAC1C,8CAA8C;IAC9C,kBAAkB;IAClB,gDAAgD;AACpD;;AAEA;IACI,KAAK,yBAAyB,EAAE;AACpC;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,oBAAoB;AACxB;;AAEA;IACI,sCAAsC;IACtC,aAAa;AACjB;;AAEA;IACI,UAAU;AACd;;AAEA,yBAAyB;;AAEzB;IACI,kBAAkB;IAClB,wBAAwB;IACxB,QAAQ;IACR,gBAAgB;IAChB,sCAAsC;IACtC,2CAA2C;IAC3C,kBAAkB;IAClB,cAAc;IACd,sCAAsC;IACtC,WAAW;AACf;;AAEA;IACI,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,8BAA8B;IAC9B,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,WAAW;IACX,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,QAAQ;IACR,iCAAiC;AACrC;;AAEA;IACI,qDAAqD;AACzD;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,eAAe;IACf,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,8BAA8B;IAC9B,+CAA+C;IAC/C,mBAAmB;AACvB;;AAEA,mBAAmB;;AAEnB;IACI,cAAc;IACd,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,+CAA+C;IAC/C,oCAAoC;IACpC,gBAAgB;AACpB;;AAEA;6CAC6C;AAC7C;IACI,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,cAAc;IACd,kDAAkD;IAClD,mCAAmC;IACnC,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,8BAA8B;IAC9B,gBAAgB;IAChB,YAAY;IACZ,oCAAoC;IACpC,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,wBAAwB;IACxB,iDAAiD;AACrD;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,yDAAyD;IACzD,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA;IACI,+BAA+B;IAC/B,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,eAAe;IACf,8BAA8B;IAC9B,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,wBAAwB;AAC5B;;AAEA;IACI,qCAAqC,UAAU,EAAE;AACrD;;AAEA;IACI,OAAO;IACP,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,uBAAuB;IACvB,gBAAgB;IAChB,+CAA+C;IAC/C,4DAA4D;IAC5D,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,WAAW;IACX,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,OAAO;IACP,qBAAqB;IACrB,qBAAqB;IACrB,8BAA8B;AAClC;;AAEA;IACI,gCAAgC;AACpC;AACA;;IAEI,cAAc;AAClB;;AAEA;IACI,gCAAgC;AACpC;AACA;;IAEI,cAAc;AAClB;;AAEA;IACI,8BAA8B;AAClC;;AAEA,gBAAgB;;AAEhB;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,+CAA+C;IAC/C,4DAA4D;IAC5D,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,8BAA8B;IAC9B,yBAAyB;AAC7B;;AAEA;IACI,OAAO;IACP,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,cAAc;IACd,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;AACnB;;AAEA,0CAA0C,cAAc,EAAE;AAC1D,0CAA0C,cAAc,EAAE;AAC1D,6CAA6C,8BAA8B,EAAE,YAAY,EAAE;;AAE3F;IACI,cAAc;IACd,WAAW;IACX,iBAAiB;IACjB,8BAA8B;IAC9B,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,cAAc;IACd,gBAAgB;IAChB,yBAAyB;IACzB,sBAAsB;IACtB,8BAA8B;IAC9B,YAAY;IACZ,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,iBAAiB;IACjB,uBAAuB;IACvB,iCAAiC;AACrC;;AAEA;;IAEI,wCAAwC;IACxC,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,cAAc;IACd,kDAAkD;IAClD,mCAAmC;IACnC,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA,mDAAmD,aAAa,EAAE;;AAElE;IACI,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,6BAA6B;IAC7B,gBAAgB;IAChB,8BAA8B;IAC9B,eAAe;IACf,mBAAmB;IACnB,gEAAgE;AACpE;;AAEA;IACI,wBAAwB;IACxB,uCAAuC;IACvC,qDAAqD;AACzD;;AAEA;IACI;QACI,wBAAwB;QACxB,yDAAyD;IAC7D;AACJ;;AAEA;IACI,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,+CAA+C;IAC/C,QAAQ;IACR,mCAAmC;AACvC;;AAEA;IACI,OAAO;IACP,uBAAuB;IACvB,YAAY;IACZ,aAAa;IACb,wBAAwB;IACxB,4DAA4D;IAC5D,eAAe;IACf,UAAU;IACV,yCAAyC;AAC7C;;AAEA;IACI,8BAA8B;IAC9B,YAAY;AAChB","sourcesContent":[".proxy_modal {\n    display: none;\n    position: absolute;\n    inset: 0;\n    background: var(--color-bg);\n    z-index: 1500;\n    flex-direction: column;\n    overflow: hidden;\n}\n\n.proxy_modal--open {\n    display: flex;\n}\n\n/* Touch/mobile: use fixed so it covers the whole viewport */\n@media (pointer: coarse) {\n    .proxy_modal {\n        position: fixed;\n    }\n}\n\n.proxy_modal--mobile-view {\n    background: var(--color-bg-2);\n}\n\n.proxy_modal__toolbar {\n    flex-shrink: 0;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: flex-end;\n    gap: 8px;\n    padding: 0 10px;\n    height: 52px;\n    border-bottom: 1px solid var(--color-border);\n    background: var(--color-bg-2);\n}\n\n.proxy_modal__content {\n    flex: 1;\n    min-height: 0;\n    display: flex;\n    flex-direction: column;\n    position: relative;\n}\n\n.proxy_modal__split {\n    flex: 1;\n    min-height: 0;\n}\n\n.proxy_modal__browser_area {\n    flex: 1;\n    min-height: 0;\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n}\n\n.proxy_modal__browser_area--split {\n    height: 100%;\n    flex: none;\n}\n\n.proxy_modal__btn {\n    flex-shrink: 0;\n    width: 32px;\n    height: 32px;\n    border-radius: 6px;\n    border: 1px solid var(--color-border);\n    background: transparent;\n    color: var(--color-text-muted);\n    font-size: 13px;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 0;\n    transition: color 0.1s, background-color 0.1s;\n}\n\n.proxy_modal__btn.active {\n    color: var(--color-accent, #4a6cf7);\n    border-color: var(--color-accent, #4a6cf7);\n}\n\n@media (pointer: fine) {\n    .proxy_modal__btn:hover {\n        color: var(--color-text);\n        background-color: var(--color-bg-3);\n    }\n}\n\n/* Landscape mobile: compact toolbar height to preserve vertical space */\n@media (pointer: coarse) and (min-aspect-ratio: 1) {\n    .proxy_modal__toolbar {\n        height: 40px;\n        padding: 0 8px;\n    }\n}\n\n.proxy_modal__scroller {\n    flex: 1;\n    overflow: auto;\n    -webkit-overflow-scrolling: touch;\n    min-height: 0;\n}\n\n.proxy_modal__scroller--mobile {\n    overflow: hidden;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    touch-action: none;\n}\n\n.proxy_modal__frame {\n    border: none;\n    display: block;\n}\n\n.proxy_modal--mobile-view .proxy_modal__frame {\n    box-shadow: 0 0 0 1px var(--color-border), 0 8px 32px rgba(0, 0, 0, 0.4);\n}\n\n.proxy_modal__url_form {\n    flex: 1;\n    min-width: 0;\n    display: flex;\n}\n\n.proxy_modal__url_input {\n    flex: 1;\n    min-width: 0;\n    height: 28px;\n    padding: 0 10px;\n    border-radius: 14px;\n    border: 1px solid var(--color-border);\n    background: var(--color-bg);\n    color: var(--color-text);\n    font-size: 12px;\n    outline: none;\n    transition: border-color 0.1s;\n}\n\n.proxy_modal__url_input:focus {\n    border-color: var(--color-accent, #4a6cf7);\n}\n\n/* TextInput overrides — make it look like the pill-shaped URL bar */\n.proxy_modal__url_form .text_input__touch_wrapper {\n    flex: 1;\n    min-width: 0;\n}\n\n.proxy_modal__url_input.text_input,\n.proxy_modal__url_form .text_input {\n    flex: 1;\n    min-width: 0;\n    height: 28px;\n    padding: 0 10px;\n    border-radius: 14px;\n    font-size: 12px;\n}\n\n.proxy_modal__url_input.text_input--vkb-active,\n.proxy_modal__url_form .text_input--vkb-active {\n    border-color: var(--color-accent, #4a6cf7);\n}\n\n.proxy_modal__url_form .text_input__cursor_overlay {\n    height: 28px;\n    padding: 0 10px;\n    border-radius: 14px;\n    font-size: 12px;\n    line-height: 28px;\n}\n\n.proxy_modal__pinch_overlay {\n    position: absolute;\n    inset: 0;\n    z-index: 5;\n    touch-action: none;\n}\n\n.proxy_modal__preloader {\n    position: absolute;\n    inset: 0;\n    z-index: 4;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: var(--color-bg);\n    pointer-events: none;\n}\n\n.proxy_modal__preloader--overlay {\n    background: rgba(0, 0, 0, 0.45);\n}\n\n.proxy_modal__spinner {\n    width: 32px;\n    height: 32px;\n    border: 3px solid rgba(255, 255, 255, 0.1);\n    border-top-color: var(--color-accent, #4a6cf7);\n    border-radius: 50%;\n    animation: proxy_modal_spin 0.8s linear infinite;\n}\n\n@keyframes proxy_modal_spin {\n    to { transform: rotate(360deg); }\n}\n\n.proxy_modal__content_controls {\n    position: absolute;\n    bottom: 12px;\n    right: 12px;\n    z-index: 10;\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n    pointer-events: auto;\n}\n\n.proxy_modal__content_controls .proxy_modal__btn {\n    background: var(--color-bg-2, #242424);\n    opacity: 0.85;\n}\n\n.proxy_modal__content_controls .proxy_modal__btn:hover {\n    opacity: 1;\n}\n\n/* Display config panel */\n\n.proxy_modal__display_config {\n    position: absolute;\n    bottom: calc(100% + 8px);\n    right: 0;\n    min-width: 170px;\n    background: var(--color-bg-2, #1e1e1e);\n    border: 1px solid var(--color-border, #333);\n    border-radius: 8px;\n    padding: 6px 0;\n    box-shadow: 0 4px 16px rgba(0,0,0,0.5);\n    z-index: 20;\n}\n\n.proxy_modal__display_config_section {\n    padding: 4px 10px 2px;\n    font-size: 10px;\n    font-weight: 600;\n    letter-spacing: 0.06em;\n    text-transform: uppercase;\n    color: var(--color-text-muted);\n    opacity: 0.6;\n}\n\n.proxy_modal__display_config_item {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    width: 100%;\n    padding: 5px 10px;\n    background: none;\n    border: none;\n    cursor: pointer;\n    gap: 8px;\n    transition: background-color 0.1s;\n}\n\n.proxy_modal__display_config_item:hover {\n    background: var(--color-bg-3, rgba(255,255,255,0.06));\n}\n\n.proxy_modal__display_config_item.active {\n    background: rgba(74,108,247,0.12);\n}\n\n.proxy_modal__display_config_label {\n    font-size: 12px;\n    color: var(--color-text, #fff);\n    white-space: nowrap;\n}\n\n.proxy_modal__display_config_desc {\n    font-size: 11px;\n    color: var(--color-text-muted);\n    font-family: \"JetBrains Mono\", Menlo, monospace;\n    white-space: nowrap;\n}\n\n/* DevTools panel */\n\n.proxy_modal__devtools {\n    flex-shrink: 0;\n    position: relative;\n    z-index: 10;\n    display: flex;\n    flex-direction: column;\n    border-top: 1px solid var(--color-border, #333);\n    background: var(--color-bg, #1a1a1a);\n    overflow: hidden;\n}\n\n/* When devtools is inside a Split pane, fill the pane and drop the top border\n   (the sash provides the visual separator) */\n.split__pane .proxy_modal__devtools {\n    height: 100%;\n    border-top: none;\n}\n\n.proxy_modal__devtools_tabs {\n    display: flex;\n    align-items: center;\n    flex-shrink: 0;\n    border-bottom: 1px solid var(--color-border, #333);\n    background: var(--color-bg-2, #111);\n    padding: 0 4px;\n}\n\n.proxy_modal__devtools_tab {\n    padding: 6px 14px;\n    font-size: 12px;\n    color: var(--color-text-muted);\n    background: none;\n    border: none;\n    border-bottom: 2px solid transparent;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    gap: 5px;\n    margin-bottom: -1px;\n    white-space: nowrap;\n}\n\n.proxy_modal__devtools_tab.active {\n    color: var(--color-text);\n    border-bottom-color: var(--color-accent, #4a6cf7);\n}\n\n.proxy_modal__devtools_badge {\n    font-size: 10px;\n    padding: 1px 5px;\n    border-radius: 8px;\n    background: var(--color-bg-hover, rgba(255,255,255,0.08));\n    color: var(--color-text-muted);\n    font-weight: 600;\n}\n\n.proxy_modal__devtools_badge--error {\n    background: rgba(239,68,68,0.2);\n    color: #ef4444;\n}\n\n.proxy_modal__devtools_clear {\n    margin-left: auto;\n    padding: 3px 10px;\n    font-size: 11px;\n    color: var(--color-text-muted);\n    background: none;\n    border: none;\n    cursor: pointer;\n    opacity: 0.7;\n    transition: opacity 0.1s;\n}\n\n@media (pointer: fine) {\n    .proxy_modal__devtools_clear:hover { opacity: 1; }\n}\n\n.proxy_modal__devtools_body {\n    flex: 1;\n    overflow-y: auto;\n    scrollbar-width: thin;\n}\n\n.proxy_modal__devtools_empty {\n    padding: 12px;\n    font-size: 12px;\n    color: var(--color-text-muted);\n}\n\n.proxy_modal__devtools_entry {\n    display: flex;\n    gap: 8px;\n    align-items: flex-start;\n    padding: 2px 8px;\n    border-bottom: 1px solid rgba(255,255,255,0.03);\n    font-family: \"JetBrains Mono\", \"Fira Code\", Menlo, monospace;\n    font-size: 11px;\n    line-height: 1.5;\n}\n\n.proxy_modal__devtools_entry_level {\n    flex-shrink: 0;\n    font-weight: 700;\n    width: 14px;\n    text-align: center;\n    opacity: 0.6;\n}\n\n.proxy_modal__devtools_entry_text {\n    flex: 1;\n    white-space: pre-wrap;\n    word-break: break-all;\n    color: var(--color-text, #fff);\n}\n\n.proxy_modal__devtools_entry--error {\n    background: rgba(239,68,68,0.08);\n}\n.proxy_modal__devtools_entry--error .proxy_modal__devtools_entry_level,\n.proxy_modal__devtools_entry--error .proxy_modal__devtools_entry_text {\n    color: #ef4444;\n}\n\n.proxy_modal__devtools_entry--warn {\n    background: rgba(234,179,8,0.08);\n}\n.proxy_modal__devtools_entry--warn .proxy_modal__devtools_entry_level,\n.proxy_modal__devtools_entry--warn .proxy_modal__devtools_entry_text {\n    color: #eab308;\n}\n\n.proxy_modal__devtools_entry--debug .proxy_modal__devtools_entry_text {\n    color: var(--color-text-muted);\n}\n\n/* Network tab */\n\n.proxy_modal__devtools_net_entry {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    padding: 3px 8px;\n    border-bottom: 1px solid rgba(255,255,255,0.03);\n    font-family: \"JetBrains Mono\", \"Fira Code\", Menlo, monospace;\n    font-size: 11px;\n    line-height: 1.5;\n}\n\n.proxy_modal__devtools_net_method {\n    flex-shrink: 0;\n    width: 38px;\n    font-size: 10px;\n    font-weight: 700;\n    color: var(--color-text-muted);\n    text-transform: uppercase;\n}\n\n.proxy_modal__devtools_net_url {\n    flex: 1;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    color: var(--color-text, #fff);\n}\n\n.proxy_modal__devtools_net_status {\n    flex-shrink: 0;\n    width: 34px;\n    text-align: center;\n    font-weight: 700;\n    font-size: 10px;\n}\n\n.proxy_modal__devtools_net_status--ok   { color: #22c55e; }\n.proxy_modal__devtools_net_status--err  { color: #ef4444; }\n.proxy_modal__devtools_net_status--pending { color: var(--color-text-muted); opacity: 0.5; }\n\n.proxy_modal__devtools_net_dur {\n    flex-shrink: 0;\n    width: 42px;\n    text-align: right;\n    color: var(--color-text-muted);\n    font-size: 10px;\n}\n\n.proxy_modal__devtools_net_type {\n    flex-shrink: 0;\n    width: 36px;\n    font-size: 9px;\n    font-weight: 600;\n    text-transform: uppercase;\n    letter-spacing: 0.04em;\n    color: var(--color-text-muted);\n    opacity: 0.6;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.proxy_modal__devtools_resize {\n    flex-shrink: 0;\n    height: 4px;\n    cursor: ns-resize;\n    background: transparent;\n    transition: background-color 0.1s;\n}\n\n.proxy_modal__devtools_resize:hover,\n.proxy_modal__devtools_resize--dragging {\n    background: var(--color-accent, #4a6cf7);\n    opacity: 0.4;\n}\n\n.proxy_modal__devtools_filter {\n    display: flex;\n    align-items: center;\n    gap: 2px;\n    padding: 3px 6px;\n    flex-shrink: 0;\n    border-bottom: 1px solid var(--color-border, #333);\n    background: var(--color-bg-2, #111);\n    overflow-x: auto;\n    scrollbar-width: none;\n}\n\n.proxy_modal__devtools_filter::-webkit-scrollbar { display: none; }\n\n.proxy_modal__devtools_filter_btn {\n    padding: 2px 8px;\n    font-size: 11px;\n    border-radius: 4px;\n    border: 1px solid transparent;\n    background: none;\n    color: var(--color-text-muted);\n    cursor: pointer;\n    white-space: nowrap;\n    transition: color 0.1s, border-color 0.1s, background-color 0.1s;\n}\n\n.proxy_modal__devtools_filter_btn.active {\n    color: var(--color-text);\n    border-color: var(--color-border, #444);\n    background: var(--color-bg-3, rgba(255,255,255,0.06));\n}\n\n@media (pointer: fine) {\n    .proxy_modal__devtools_filter_btn:hover {\n        color: var(--color-text);\n        background: var(--color-bg-hover, rgba(255,255,255,0.06));\n    }\n}\n\n.proxy_modal__console_input_area {\n    flex-shrink: 0;\n    display: flex;\n    align-items: center;\n    padding: 4px 8px;\n    border-top: 1px solid var(--color-border, #333);\n    gap: 6px;\n    background: var(--color-bg-2, #111);\n}\n\n.proxy_modal__console_input {\n    flex: 1;\n    background: transparent;\n    border: none;\n    outline: none;\n    color: var(--color-text);\n    font-family: \"JetBrains Mono\", \"Fira Code\", Menlo, monospace;\n    font-size: 12px;\n    padding: 0;\n    caret-color: var(--color-accent, #4a6cf7);\n}\n\n.proxy_modal__console_input::placeholder {\n    color: var(--color-text-muted);\n    opacity: 0.4;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
